<template>
  <portal to="modals">
    <div v-if="visible" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div class="bg-white rounded-lg p-6 shadow-lg text-left" style="width: 400px; max-width: 90vw;">
        <div class="mb-4">
          <h3 
            class="text-lg font-semibold mb-2 flex items-center" 
            :class="isFilePii ? 'text-red-600' : 'text-orange-600'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 mr-1" style="margin-left: -10px;">
              <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
            </svg>
            
            <span>
              {{ isFilePii ? '파일 개인정보 알림' : '컨텐츠 필터링 알림' }}
            </span>
          </h3>
          <p class="text-gray-700">&bull;&nbsp;{{ errorMessage }}</p>
        </div>
        
        <div class="flex justify-center gap-4 mt-6">
          <template v-if="!singleButton">
            <button 
              class="px-16 py-2 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-200 min-w-[80px]" 
              @click="$emit('cancel')"
              :disabled="loading"
              title="취소"
            >
              취소
            </button>
            <button 
              class="px-16 py-2 bg-blue-200 text-white rounded hover:bg-blue-500 min-w-[100px]" 
              @click="$emit('confirm')"
              :disabled="loading"
              title="전송"
            >
              전송
            </button>
          </template>
          <template v-else>
            <button 
              class="px-16 py-2 bg-blue-200 text-white rounded hover:bg-blue-500 min-w-[100px]" 
              @click="$emit('cancel')"
              :disabled="loading"
              title="확인"
            >
              확인
            </button>
          </template>
        </div>
        
        <div v-if="loading" class="flex flex-row items-center justify-center mt-4 h-6">
          <span class="flex items-center text-gray-500 font-semibold" style="font-size:1.1em;">
            <svg class="animate-spin h-5 w-5 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            답변을 작성 중입니다
          </span>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: 'FilteringModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    errorMessage: {
      type: String,
      default: '부적절한 내용이 포함되어 있을 수 있습니다.'
    },
    loading: {
      type: Boolean,
      default: false
    },
    isFilePii: {
      type: Boolean,
      default: false
    },
    singleButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel', 'confirm']
}
</script>

<style scoped>
</style> 